import PageListPage from './PageListPage';

export default PageListPage;
